import { LangCodes } from '@tsl-frontend/tsl-locale';
import { AppConfigKeys } from './app-config-keys';

const enGBAppConfig: Record<AppConfigKeys, string> = {
    [AppConfigKeys.USER_REGION]: LangCodes.GB,
    [AppConfigKeys.PRIVACY_POLICY_URL]:
        'https://help.thirdspacelearning.com/en/articles/13871413-uk-pupil-privacy-at-third-space-learning',
    [AppConfigKeys.CONTACT_PHONE]: '0203 771 0096',
    [AppConfigKeys.PRIMARY_WELCOME_LINK]:
        'https://thirdspacelearning-2.wistia.com/medias/0u9hdhpvd7',
    [AppConfigKeys.SECONDARY_WELCOME_LINK]:
        'https://thirdspacelearning-2.wistia.com/medias/qfw177573i',
};

export default enGBAppConfig;
